import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

export default function Settings() {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="p-8 max-w-4xl mx-auto">
      <h2 className="text-2xl font-light uppercase tracking-widest mb-8 border-b border-[#004B87]/20 pb-4">System Preferences</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div className="md:col-span-1 space-y-2">
          {['General', 'Notifications', 'Billing', 'Team', 'Integrations'].map((tab, i) => (
            <button key={tab} className={`w-full text-left px-4 py-2 text-sm uppercase tracking-wider font-mono ${i === 0 ? 'bg-[#004B87]/10 text-[#C1440E] border-l-2 border-[#C1440E]' : 'text-[#004B87]/60 hover:bg-[#004B87]/5 hover:text-[#004B87]'}`}>
              {tab}
            </button>
          ))}
        </div>
        
        <div className="md:col-span-2 space-y-6">
          <div className="tech-panel p-6">
             <h3 className="text-sm font-bold uppercase tracking-widest mb-4">Company Profile</h3>
             <div className="space-y-4">
               <div>
                 <label className="block text-[10px] uppercase font-mono text-[#004B87]/60 mb-1">Company Name</label>
                 <input type="text" defaultValue="Apex Property Management" className="w-full bg-transparent border-b border-[#004B87]/30 pb-1 text-sm focus:outline-none focus:border-[#C1440E]" />
               </div>
               <div>
                 <label className="block text-[10px] uppercase font-mono text-[#004B87]/60 mb-1">Support Email</label>
                 <input type="email" defaultValue="support@apexpm.com" className="w-full bg-transparent border-b border-[#004B87]/30 pb-1 text-sm focus:outline-none focus:border-[#C1440E]" />
               </div>
               <div className="pt-4">
                 <button className="btn-blueprint text-xs">Save Changes</button>
               </div>
             </div>
          </div>

          <div className="tech-panel p-6 border-l-2 border-l-[#C1440E]">
             <h3 className="text-sm font-bold uppercase tracking-widest mb-2 text-[#C1440E]">Danger Zone</h3>
             <p className="text-xs text-[#004B87]/70 mb-4">Permanently delete your account and all associated data. This action cannot be undone.</p>
             <button className="border border-[#C1440E] text-[#C1440E] px-4 py-2 text-xs uppercase hover:bg-[#C1440E] hover:text-[#FFFFF0] transition-colors">
               Initialize Deletion Protocol
             </button>
          </div>
        </div>
      </div>
    </motion.div>
  );
}